// Result View - Intermediate screen between questionnaire and strategy selection
// Shows success message and CTA to continue to strategy selection

import { Dispatchers } from '@client/new/helpers/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket } from '@fortawesome/pro-solid-svg-icons';
import { PlaybookLogo } from '@design-system/components/logo/PlaybookLogo';
import { OnboardingVMActionMap } from '../view-model/Onboarding.viewModel';
import * as styles from './Result.view.css';

type ResultViewProps = {
  avatarUrls: [string, string];
  isSaving: boolean;
} & Dispatchers<OnboardingVMActionMap>;

export const ResultView = ({
  avatarUrls,
  isSaving,
  lazyDispatch,
}: ResultViewProps) => {
  const [avatar1, avatar2] = avatarUrls;

  return (
    <div className={styles.container} data-testid="result-view">
      <header className={styles.header}>
        <PlaybookLogo showGlyph showName height={24} color="B-100" />
      </header>

      <main className={styles.main}>
        <div className={styles.card}>
          <div className={styles.avatarsContainer}>
            {avatar1 && (
              <img src={avatar1} alt="Creator" className={styles.avatar} />
            )}
            {avatar2 && (
              <img
                src={avatar2}
                alt="Creator"
                className={styles.avatarSecond}
              />
            )}
          </div>

          <span className={styles.subtitle}>
            You&apos;re in the right place!
          </span>

          <h1 className={styles.heading}>
            We&apos;ve helped launch successful businesses for hundreds of
            creators like you!
          </h1>

          <p className={styles.supportingText}>
            Use one of these strategies to chart your path to your first $$$.
          </p>

          <button
            type="button"
            className={styles.ctaButton}
            onClick={lazyDispatch('GoNext')}
            disabled={isSaving}
            data-testid="get-strategy-button"
          >
            <FontAwesomeIcon icon={faRocket} className={styles.ctaIcon} />
            Get your Strategy
          </button>
        </div>
      </main>
    </div>
  );
};
